(ns frontend.view.components.timeline.events
  (:require [common.audit-ops :as audit-ops]
            [frontend.view.components.timeline.db :as db]))

(defn filter-entry [filters {:keys [audit/op]}]
  (let [[icon-class icon-test filter-kw] (audit-ops/audit-ops op)
        kws #{:updates :status-changes :comments :interactions :emails}
        all-filters-off? (and (kws filter-kw)
                              (->> kws (map @filters) (every? not)))
        filter? (if (nil? filter-kw)
                  false
                  (let [set-filter (@filters filter-kw)]
                    (or
                      (nil? set-filter)
                      set-filter
                      all-filters-off?)))]
    filter?))

(defn init []
  (swap! db/state assoc :count db/default-entries-count)
  (swap! db/comment-state assoc
         :hidden false
         :comment "")
  (swap! db/phone-state assoc
         :hidden false
         :comment "")
  (swap! db/filters-state assoc
         :updates false
         :status-changes false
         :comments false
         :interactions false
         :emails false
         :system false))
